import { render, staticRenderFns } from "./VehicleSorry.vue?vue&type=template&id=2ecc12ca&scoped=true&"
import script from "./VehicleSorry.vue?vue&type=script&lang=js&"
export * from "./VehicleSorry.vue?vue&type=script&lang=js&"
import style0 from "./VehicleSorry.vue?vue&type=style&index=0&id=2ecc12ca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ecc12ca",
  null
  
)

export default component.exports